import React from 'react';

const QuizFooter = props => {
	const { onClick, currentQuestion, totalQuestions } = props;
	return (
		<div className="calculator-footer__nav">
			<span
				onClick={() => onClick('dec')}
				className="calculator-footer__nav-move">
				&larr;
			</span>
			<span className="calculator-footer__nav-location">
				{currentQuestion + 1} / {totalQuestions}
			</span>
			<span
				onClick={() => props.onClick('inc', true)}
				className="calculator-footer__nav-move">
				&rarr;
			</span>
		</div>
	);
};

export default QuizFooter;



// WEBPACK FOOTER //
// ./src/components/quiz/QuizFooter.js